import React, { useState, useEffect } from 'react';
import { Link, useHistory, useParams } from "react-router-dom";
import { useGlobal } from 'reactn';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import Selectivity from 'selectivity/react';
import DatePicker from "react-datepicker";
import Switch from 'react-switch';
import _ from 'lodash';
import useLocalStorage from "stores/useLocalStorage.js";

import { useAuth } from 'stores/auth';
import { useApi } from 'stores/api';
import { ADDRESS_TYPE } from 'stores/const';
import { fmtPrice, genGuid, isValidEmail } from 'stores/utils';
import Stepper from 'components/Stepper';
import AddressBlock from 'components/AddressBlock';
import FixedBottom from 'components/FixedBottom';

const BWPersonalData = (props) => {
  const auth = useAuth();
  let history = useHistory();
  const api = useApi();
  const { t } = useTranslation(['wizard-personaldata']);

  let { action } = useParams();
  const [LSIsGuestBooking, setLSIsGuestBooking] = useLocalStorage('ls_igb'); //gd=is guest booking
  const [LSGuestData] = useLocalStorage('ls_gd');
  const [orderId] = useGlobal('orderId');
  const [currentTxnId] = useGlobal('currentTxnId');
  const [objectDetails] = useGlobal('objectDetails');
  const [showGuestLogin, setShowGuestLogin] = useGlobal('showGuestLogin');
  const [isDBA, setIsDBA] = useGlobal('isDBA');
  const [currentTxn, setCurrentTxn] = useState(null);
  const [personalData, setPersonalData] = useState(null);
  const [businessPartner, setBusinessPartner] = useState({
    refSalutationId: '',
    FirstName: '',
    Name: '',
    AddressName: '',
    Email: '',
    Phone: '',
    Mobile: '',
  });
  const [addressPost, setAddressPost] = useState({
    Street: '',
    AddressAddition: '',
    City: '',
    PostalCode: '',
    refAddressTypeId: ADDRESS_TYPE.POSTAL,
    refCountryId: '',
  });
  const [addressBill, setAddressBill] = useState({
    Street: '',
    AddressAddition: '',
    City: '',
    PostalCode: '',
    refAddressTypeId: ADDRESS_TYPE.BILLING,
    refCountryId: '',
  });
  const [errors, setErrors] = useState({});

  const findErrors = () => {
    const { refSalutationId, FirstName, Name, Email, Mobile } = businessPartner;
    const { Street, City, PostalCode, refCountryId } = addressPost;
    const newErrors = {};
    // name errors
    if (!refSalutationId || refSalutationId === '') newErrors.refSalutationId = t("validation-salutation");
    if (!FirstName || FirstName === '') newErrors.FirstName = t("validation-firstName");
    if (!Name || Name === '') newErrors.Name = t("validation-lastName");
    if (!isValidEmail(Email)) newErrors.Email = t("validation-email");
    if (!Mobile || Mobile === '') newErrors.Mobile = t("validation-mobile");

    if (!Street) newErrors.Post_Street = t("validation-Post_Street");
    if (!PostalCode) newErrors.Post_PostalCode = t("validation-Post_Code");
    if (!City) newErrors.Post_City = t("validation-Post_City");
    if (!refCountryId) newErrors.Post_refCountryId = t("validation-Post_Country");

    if (isDBA) {
      if (!addressBill.Street) newErrors.Bill_Street = t("validation-Bill_Street");
      if (!addressBill.PostalCode) newErrors.Bill_PostalCode = t("validation-Bill_Code");
      if (!addressBill.City) newErrors.Bill_City = t("validation-Bill_City");
      if (!addressBill.refCountryId) newErrors.Bill_refCountryId = t("validation-Bill_Country");
    }
    return newErrors;
  }

  const cleanAddress = (addressObj) => {
    let { Street, AddressAddition, AddressName, City, PostalCode, refAddressTypeId, refCountryId } = addressObj;
    return { Street, AddressAddition, AddressName, City, PostalCode, refAddressTypeId, refCountryId };
  }

  const resetIdsIfSame = (hbua, cobpa) => {
    let p1 = hbua.find(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
    let p2 = cobpa.find(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
    if (p1 && p2 && (p1.Id === p2.Id)) {
      p1.Id = genGuid();
    }

    let b1 = hbua.find(item => item.refAddressTypeId === ADDRESS_TYPE.BILLING);
    let b2 = cobpa.find(item => item.refAddressTypeId === ADDRESS_TYPE.BILLING);
    if (b1 && b2 && (b1.Id === b2.Id)) {
      b1.Id = genGuid();
    }
  }

  const updatePersonalData = async (orderIdNew) => {
    const currentProfile = { ...personalData };

    let { refSalutationId, FirstName, Name, AddressName, Email, Phone, Mobile } = businessPartner;
    currentProfile.OrganizationBusinessPartner[0] = {
      ...currentProfile.OrganizationBusinessPartner[0],
      refSalutationId, FirstName, Name, AddressName, Email, Phone, Mobile
    }

    const cleanAP = cleanAddress(addressPost);
    const cleanAB = cleanAddress(isDBA ? addressBill : { ...addressPost, refAddressTypeId: ADDRESS_TYPE.BILLING });

    let hbu = personalData.HomeBusinessUnit[0];
    let hbuAddresses = hbu.BusinessUnitAddress;
    let hbuAddressesNew = [];
    let cobp = personalData.CustomerOrganizationBusinessPartner[0];

    let cobpAddresses = cobp?.CustomerOrganizationBusinessPartnerAddress;
    let cobpAddressesNew = [];

    if (hbuAddresses && hbuAddresses.length > 0) {
      let paIndex = hbuAddresses.findIndex(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
      if (paIndex !== -1) {
        let hbuPA = hbuAddresses[paIndex];
        hbuAddressesNew.push({
          ...hbuPA, ...cleanAP,
          refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
        });
      } else {
        const hbuPAId = genGuid();
        const hbuPostAddress = {
          ...cleanAP, Id: hbuPAId,
          refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
        };
        hbuAddressesNew.push(hbuPostAddress);
      }

      let baIndex = hbuAddresses.findIndex(item => item.refAddressTypeId === ADDRESS_TYPE.BILLING);
      if (baIndex !== -1) {
        let hbuBA = hbuAddresses[baIndex];
        hbuAddressesNew.push({
          ...hbuBA, ...cleanAB,
          refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
        });
      } else {
        const hbuBAId = genGuid();
        const hbuBillAddress = {
          ...cleanAB, Id: hbuBAId,
          refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
        };
        hbuAddressesNew.push(hbuBillAddress);
      }
    } else {
      const hbuPAId = genGuid();
      const hbuPostAddress = {
        ...cleanAP, Id: hbuPAId,
        refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
      };
      hbuAddressesNew.push(hbuPostAddress);

      const hbuBAId = genGuid();
      const hbuBillAddress = {
        ...cleanAB, Id: hbuBAId,
        refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
      };
      hbuAddressesNew.push(hbuBillAddress);
    }

    if (cobpAddresses && cobpAddresses.length > 0) {
      let paIndex = cobpAddresses.findIndex(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
      if (paIndex !== -1) {
        cobpAddressesNew.push({ ...cobpAddresses[paIndex], ...cleanAP });
      } else {
        const cobpPAId = genGuid();
        const cobpPostAddress = { ...cleanAP, Id: cobpPAId };
        cobpAddressesNew.push(cobpPostAddress);
      }
      let baIndex = cobpAddresses.findIndex(item => item.refAddressTypeId === ADDRESS_TYPE.BILLING);
      if (baIndex !== -1) {
        cobpAddressesNew.push({ ...cobpAddresses[baIndex], ...cleanAB });
      } else {
        const cobpBAId = genGuid();
        const cobpBillAddress = { ...cleanAB, Id: cobpBAId };
        cobpAddressesNew.push(cobpBillAddress);
      }
    }

    resetIdsIfSame(hbuAddressesNew, cobpAddressesNew);
    currentProfile.HomeBusinessUnit[0].BusinessUnitAddress = hbuAddressesNew;
    if(currentProfile.CustomerOrganizationBusinessPartner && currentProfile.CustomerOrganizationBusinessPartner.length) {
      currentProfile.CustomerOrganizationBusinessPartner[0].CustomerOrganizationBusinessPartnerAddress = cobpAddressesNew;
    }
    let result = await api.updatePersonalData(orderIdNew ? orderIdNew : orderId, cobpAddresses, currentProfile, auth.user.Id);
    return result;
  }

  const onClickOverview = async (e) => {
    e.preventDefault();
    const newErrors = findErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }

    let result;
    let canProceedToOverview = false;
    if (action && action === 'edit') {
      if (hasProfileChanges()) {
        console.log('address changes exist');
        if (LSIsGuestBooking) {
          let addressBilling = isDBA ? addressBill : { ...addressPost, refAddressTypeId: ADDRESS_TYPE.BILLING };
          api.storeGuestData(businessPartner, addressPost, addressBilling);
          console.log('address updated and stored LS');
          canProceedToOverview = true;
        } else {
          if (auth.user) {
            result = await updatePersonalData();
            if (result) {
              canProceedToOverview = true;
            }
          }
          else {
            console.log('not logged in. redirecting to homepage.');
            history.push('/');
          }
        }
      } else {
        canProceedToOverview = true;
      }
      if (canProceedToOverview) {
        proceedToOverview(orderId);
      }
      return;
    }
    const orderIdNew = await api.createOrUpdateOrder(null, currentTxnId);
    if (hasProfileChanges()) {
      if (LSIsGuestBooking) {
        let addressBilling = isDBA ? addressBill : { ...addressPost, refAddressTypeId: ADDRESS_TYPE.BILLING };
        api.storeGuestData(businessPartner, addressPost, addressBilling);
        canProceedToOverview = true;
      } else {
        if (auth.user) {
          result = await updatePersonalData(orderIdNew);
          if (result) {
            canProceedToOverview = true;
          }
        }
        else {
          console.log('not logged in. redirecting to homepage.');
          history.push('/');
        }
      }
    } else {
      canProceedToOverview = true;
    }
    if (canProceedToOverview) {
      proceedToOverview(orderIdNew);
    }
  }

  const proceedToOverview = (order_id) => {
    history.push('/wizard/overview');
  }

  const hasProfileChanges = () => {
    if (isDBA || LSIsGuestBooking) return true;
    let cobp = personalData.CustomerOrganizationBusinessPartner[0];
    if (cobp) {
      let oriBP = {
        refSalutationId: cobp.refSalutationId,
        FirstName: cobp.FirstName,
        Name: cobp.Name,
        AddressName: cobp.AddressName,
        Email: cobp.Email,
        Phone: cobp.Phone,
        Mobile: cobp.Mobile
      };
      let nowBP = {
        refSalutationId: businessPartner.refSalutationId,
        FirstName: businessPartner.FirstName,
        Name: businessPartner.Name,
        AddressName: businessPartner.AddressName,
        Email: businessPartner.Email,
        Phone: businessPartner.Phone,
        Mobile: businessPartner.Mobile
      }
      let isSameBP = _.isEqual(oriBP, nowBP);
      if (!isSameBP) {
        console.log('person details changed');
        return !isSameBP;
      }
      let oriPostAddress = cobp.CustomerOrganizationBusinessPartnerAddress.find(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
      if (oriPostAddress) {
        let areSame = _.isEqual(addressPost, oriPostAddress);
        console.log('address same:' + areSame);
        return !areSame;
      }
    }
    return true;
  }

  const onCancelGuestLogin = () => {
    setLSIsGuestBooking(false);
  }

  useEffect(() => {
    const fetchPersonalData = async (lesseeId) => {
      let pData = await api.fetchPersonalData(lesseeId);
      if (pData) {
        setPersonalData(pData);
        setBusinessPartner(pData.OrganizationBusinessPartner[0]);
        let cobp = pData.CustomerOrganizationBusinessPartner[0];
        if (cobp) {
          let pAddress = cobp.CustomerOrganizationBusinessPartnerAddress?.find(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
          if (pAddress) {
            setAddressPost({ ...pAddress });
          }
          let bAddress = cobp.CustomerOrganizationBusinessPartnerAddress?.find(item => item.refAddressTypeId === ADDRESS_TYPE.BILLING);
          if (!bAddress) {
            bAddress = { ...pAddress, Id: genGuid(), refAddressTypeId: ADDRESS_TYPE.BILLING }
          }
          setAddressBill({ ...bAddress });
        }
      }
    }

    const fetchGuestData = () => {
      if (!LSGuestData) return;
      let { businessPartner, addressPost, addressBill } = LSGuestData;
      setBusinessPartner(businessPartner);
      setAddressPost(addressPost);
      setAddressBill(addressBill);
    }

    const loadTxn = async () => {
      let cTxn = await api.fetchTransaction(currentTxnId);
      setCurrentTxn(cTxn);
    }

    if (LSIsGuestBooking) {
      console.log('setting geust data...');
      fetchGuestData();
    }
    else if (auth.user) {
      fetchPersonalData(auth.user.Id);
    }
    loadTxn();

  }, [auth.user]);

  return (
    <>
      <Stepper activeStep="contact" />
      <section className="wizard-container">
        <div className="wrapper">
          <div className="row wizard-content">
            <div className="column-12">
              <h3 className="mali-blue margin-bottom">{t("personalData")}</h3>
              {(!auth.user && !LSIsGuestBooking) &&
                <LoginScreen setShowGuestLogin={setShowGuestLogin} setLSIsGuestBooking={setLSIsGuestBooking}
                  businessUnit={objectDetails?.businessUnit} />}
              {(auth.user || LSIsGuestBooking) && <PersonalData
                errors={errors} setErrors={setErrors}
                businessPartner={businessPartner} setBusinessPartner={setBusinessPartner}
                addressPost={addressPost} setAddressPost={setAddressPost}
                addressBill={addressBill} setAddressBill={setAddressBill}
                isDBA={isDBA} setIsDBA={setIsDBA}
                showGuestLogin={showGuestLogin} setShowGuestLogin={setShowGuestLogin} />}
            </div>
          </div>
        </div>
      </section>
      {
        <FixedBottom>
          <div className="wrapper">
            {(auth.user || LSIsGuestBooking) && <div className="row fixedBottom-content">
              <div className="column-8 fixedBottom-right">
                {currentTxn && <div className="fixedBottom-price">
                  <span className="amount">{objectDetails?.businessUnit?.Currency_Name} {fmtPrice(currentTxn.TotalDiscountedPrice)}</span>
                </div>}
                <div className="fixedBottom-buttons btn-forward">
                  <Link to={`/wizard/overview`} onClick={onClickOverview} id="btn-book-object" className="book-object">
                    {t("btnOverview")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
              <div className="column-4 fixedBottom-left">
                <div className="fixedBottom-buttons btn-back">
                  {!LSIsGuestBooking && <Link to={`/search`} className="book-object">
                    <i className="fa fa-times-circle" aria-hidden="true"></i> {t("btnCancel")}
                  </Link>}
                  {LSIsGuestBooking && <div className="cancel-login">
                    <a className="back small" onClick={onCancelGuestLogin}><i className="fa fa-times-circle" aria-hidden="true"></i> {t("btnCancelGuestLogin")}</a>
                  </div>}
                </div>
              </div>
            </div>}
          </div>
        </FixedBottom>
      }
    </>
  );
}

const LoginScreen = (props) => {
  const { t } = useTranslation(['wizard-personaldata']);
  const { setLSIsGuestBooking, businessUnit } = props;

  const [masterData] = useGlobal('masterData');
  const loginMessage = businessUnit?.LoginMessage;
  const isGuestAllowed = !masterData.organization.IsClosedUserGroup;
  const [iFrameError, setIframeError] = useState(false);


  const onClickLoginAsGuest = e => {
    setLSIsGuestBooking(true);
  }

  const onLoadIframe = () => {
    var iFrame = document.getElementById("login-iframe");
    if (iFrame) {
      let hasError = iFrame.contentWindow.document.querySelector(".alert-danger") != null;
      setIframeError(hasError);
    }
  }

  return (
    <div className="login-container" id="bw-login-container">
      {loginMessage && <div className="row loginMessage">
        <h5>{loginMessage}</h5>
      </div>}
      <div className={`row iframe-holder${iFrameError ? ' iframe-error' : ''}`}>
        <iframe src={'/auth'} width={'100%'} height={'100%'} frameBorder="0" scrolling="no"
          id="login-iframe" onLoad={onLoadIframe}></iframe>
      </div>
      <div className="row">
        {isGuestAllowed &&
          <a className="guest small" onClick={onClickLoginAsGuest}>{t("loginAsGuest")} <i className="fa fa-user" aria-hidden="true"></i></a>
        }
      </div>
    </div>
  );
}

const PersonalData = (props) => {
  const { t } = useTranslation(['wizard-personaldata']);
  const [masterData] = useGlobal('masterData');

  const { isDBA, setIsDBA, businessPartner, setBusinessPartner,
    addressPost, setAddressPost,
    addressBill, setAddressBill,
    errors, setErrors } = props;

  const updateBP = (e) => {
    let field = e.target.name;
    setBusinessPartner({
      ...businessPartner, [field]: e.target.value
    });
    if (!!errors[field]) setErrors({
      ...errors,
      [field]: null
    })
  }

  const onChangeSalutation = (e) => {
    setBusinessPartner({
      ...businessPartner, refSalutationId: e.value
    });
    if (!!errors['refSalutationId']) setErrors({
      ...errors,
      'refSalutationId': null
    })
  };

  const handleDBASwitch = (isChecked) => {
    setIsDBA(isChecked);
  };

  return (
    <div className="loggedin-container personaldata-container">
      <div className="row customer-info-container">
        <div className="column-8 offset-2">
          <h4>{t("customerInformation")}</h4>
        </div>
        <div className="column-8 offset-2">

          <div className="form-group">
            <label className="form-label">{t("salutation")} *</label>
            <div className="form-control form-select">
              <Selectivity.React
                multiple={false}
                items={masterData.salutations}
                placeholder={t('anrede')}
                className="sr-wrapper"
                value={businessPartner.refSalutationId}
                onChange={onChangeSalutation}
              />
            </div>
            <Form.Control.Feedback type='invalid'>
              {errors.refSalutationId}
            </Form.Control.Feedback>
          </div>

          <div className="form-group">
            <label className="form-label">{t("firstName")} *</label>
            <input className="form-control" type="text" name="FirstName" value={businessPartner.FirstName} onChange={updateBP} />
            <Form.Control.Feedback type='invalid'>
              {errors.FirstName}
            </Form.Control.Feedback>
          </div>

          <div className="form-group">
            <label className="form-label">{t("lastName")} *</label>
            <input className="form-control" type="text" name="Name" value={businessPartner.Name} onChange={updateBP} />
            <Form.Control.Feedback type='invalid'>
              {errors.Name}
            </Form.Control.Feedback>
          </div>

          <div className="form-group">
            <label className="form-label">{t("organization")}</label>
            <input className="form-control" type="text" name="AddressName" value={addressPost.AddressName}
              onChange={e => setAddressPost({ ...addressPost, AddressName: e.target.value })} />
            <Form.Control.Feedback type='invalid'>
              {errors.AddressName}
            </Form.Control.Feedback>
          </div>

          <div className="form-group">
            <label className="form-label">{t("email")} *</label>
            <input className="form-control" type="email" name="Email" value={businessPartner.Email} onChange={updateBP} />
            <Form.Control.Feedback type='invalid'>
              {errors.Email}
            </Form.Control.Feedback>
          </div>

          <div className="form-group">
            <label className="form-label">{t("phone")}</label>
            <input className="form-control" type="tel" name="Phone" value={businessPartner.Phone} onChange={updateBP} />
            <Form.Control.Feedback type='invalid'>
              {errors.Phone}
            </Form.Control.Feedback>
          </div>

          <div className="form-group">
            <label className="form-label">{t("mobile")} *</label>
            <input className="form-control" type="tel" name="Mobile" value={businessPartner.Mobile} onChange={updateBP} />
            <Form.Control.Feedback type='invalid'>
              {errors.Mobile}
            </Form.Control.Feedback>
          </div>

        </div>
      </div>

      <div className="row post-address-container">
        <AddressBlock addressTitle="postalAddress"
          address={addressPost} setAddress={setAddressPost}
          errors={errors} setErrors={setErrors} />
        <div className="column-8 offset-2 use-same-address">
          <label>
            <span>{t("useDifferentBillingAddress")}</span>
            <Switch
              checked={isDBA}
              onChange={handleDBASwitch}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={30}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={20}
              width={48}
              className={isDBA ? "react-switch on" : "react-switch off"}
            />
          </label>
        </div>
      </div>

      {isDBA && <div className="row billing-address-container">
        <AddressBlock addressTitle="billingAddress"
          address={addressBill} setAddress={setAddressBill}
          errors={errors} setErrors={setErrors} />
      </div>}

    </div>
  )
}

export default BWPersonalData;